import React, { Component } from 'react';
import { isObject, values } from 'lodash';

import { mergeClassNames, mergeStringsWithSpaces } from 'utils/functions';
import { Button, Col, Row } from 'bs';
import { FormGroup } from './Input';

export class SelectButton extends Component {
    render() {
        let colProps = this.props.colProps;
        if (!colProps) {
            // let's guess at a decent default
            colProps = { sm: parseInt(12 / this.props.options.length, 10) };
        }
        let {
            errorText,
            className,
            helpText,
            label,
            name,
            onBlur,
            onChange,
            options,
            value,
            ...domProps
        } = this.props;
        const errorClass = errorText ? 'is-invalid' : '';
        className = mergeClassNames('bg-white', className, errorClass);

        if (errorText && isObject(errorText)) {
            errorText = mergeStringsWithSpaces(values(errorText));
        }

        return (
            <FormGroup className='border-0'>
                {label && <label htmlFor={`id_${name}`}>{label}</label>}
                <Row className={className} id={`id_${name}`}>
                    {options.map(option => {
                        const selected = option.value === value;
                        let label = option.label || option.display_name;
                        if (!selected && typeof selected !== 'undefined') {
                            label = <span className='text-muted'>{label}</span>;
                        }

                        return (
                            <Col key={option.value} className='mb-3' {...colProps}>
                                <Button
                                    {...domProps}
                                    flavor={selected ? 'success' : 'light'}
                                    active={selected}
                                    block={true}
                                    name={name}
                                    onClick={() => onChange(option.value)}
                                    onBlur={onBlur}
                                    id={`${option.value}`} // id for formik, template literal for undefined and booleans
                                >
                                    {label}
                                </Button>
                            </Col>
                        );
                    })}
                </Row>
                <Row>
                    <Col>
                        {errorText && (
                            <small className='form-text text-danger'>{errorText}</small>
                        )}
                        {helpText && (
                            <small className='form-text text-muted'>{helpText}</small>
                        )}
                    </Col>
                </Row>
            </FormGroup>
        );
    }
}

export default SelectButton;
